'use strict';

var _tslib = require('../../../../../_virtual/_tslib.js');
var axios = require('axios');
var common = require('../../../../../utils/common/common.js');
var object = require('../../../../../utils/common/dataTypes/object.js');
var string = require('../../../../../utils/common/dataTypes/string.js');
var Api_constants = require('../../Api/constants/Api.constants.js');
var APi_utils = require('../../Api/utils/APi.utils.js');
var S3_constants = require('../constants/S3.constants.js');

/**
 * get signed url from s3
 * @returns signed url of a file from s3
 */
var getS3SignedUrl = function (_a) {
    var bucket = _a.bucket, key = _a.key, _b = _a.expiresIn, expiresIn = _b === void 0 ? S3_constants.EXPIRY_TIME : _b, lamdaBaseURL = _a.lamdaBaseURL, authorizationToken = _a.authorizationToken;
    return _tslib.__awaiter(void 0, void 0, void 0, function () {
        var payload, queryUrl, options, response, url;
        return _tslib.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    payload = {
                        key: key,
                        url_required_for: S3_constants.url_required_for_keys.GET,
                        expirytime: expiresIn,
                        bucket_name: bucket,
                    };
                    queryUrl = "".concat(lamdaBaseURL, "/").concat(S3_constants.GET_SIGNED_URL_API, "?").concat(APi_utils.queryParamsStringify(payload));
                    options = {
                        method: Api_constants.API_METHODS.GET,
                        headers: {
                            authorizationToken: authorizationToken,
                        },
                    };
                    return [4 /*yield*/, fetch(queryUrl, options)];
                case 1:
                    response = _c.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    url = _c.sent();
                    return [2 /*return*/, url];
            }
        });
    });
};
/**
 * lamda function to upload file to s3
 * @returns Loaction url of the file uploaded if getFileLocation param is provided
 */
var uploadToS3 = function (_a) {
    var bucket = _a.bucket, key = _a.key, file = _a.file, _b = _a.isFilePublic, isFilePublic = _b === void 0 ? false : _b, lamdaBaseURL = _a.lamdaBaseURL, authorizationToken = _a.authorizationToken, abortSignal = _a.abortSignal, onProgress = _a.onProgress, onAbort = _a.onAbort, contentType = _a.contentType;
    return _tslib.__awaiter(void 0, void 0, void 0, function () {
        var payload, queryUrl, options, response, uploadObj_1, formData_1, uploadOptions, uploadResponse, error_1;
        return _tslib.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 4, , 5]);
                    payload = {
                        key: key,
                        url_required_for: S3_constants.url_required_for_keys.UPLOAD,
                        expirytime: S3_constants.EXPIRY_TIME,
                        bucket_name: bucket,
                        content_type: contentType !== null && contentType !== void 0 ? contentType : file.type,
                    };
                    if (isFilePublic) {
                        payload.is_public_read = isFilePublic;
                    }
                    queryUrl = "".concat(lamdaBaseURL, "/").concat(S3_constants.GET_SIGNED_URL_API, "?").concat(APi_utils.queryParamsStringify(payload));
                    options = {
                        method: Api_constants.API_METHODS.GET,
                        headers: {
                            authorizationToken: authorizationToken,
                        },
                    };
                    return [4 /*yield*/, fetch(queryUrl, options)];
                case 1:
                    response = _c.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    uploadObj_1 = _c.sent();
                    if (string.checkIsStringEmpty(uploadObj_1 === null || uploadObj_1 === void 0 ? void 0 : uploadObj_1.url) ||
                        object.checkIsObjectEmpty(uploadObj_1 === null || uploadObj_1 === void 0 ? void 0 : uploadObj_1.fields)) {
                        throw new Error("Invalid upload object received from lamda");
                    }
                    formData_1 = new FormData();
                    Object.keys(uploadObj_1.fields).forEach(function (field) {
                        formData_1.append(field, uploadObj_1.fields[field]);
                    });
                    formData_1.append("file", file);
                    uploadOptions = {
                        headers: {
                            authorizationToken: authorizationToken,
                        },
                        onUploadProgress: function (progressEvent) {
                            if (progressEvent.total && progressEvent.loaded) {
                                if (onProgress) {
                                    onProgress({
                                        total: progressEvent.total,
                                        loaded: progressEvent.loaded,
                                    });
                                }
                            }
                        },
                    };
                    if (abortSignal) {
                        uploadOptions.signal = abortSignal;
                    }
                    return [4 /*yield*/, axios(_tslib.__assign(_tslib.__assign({}, uploadOptions), { method: "post", url: uploadObj_1 === null || uploadObj_1 === void 0 ? void 0 : uploadObj_1.url, data: formData_1 }))];
                case 3:
                    uploadResponse = _c.sent();
                    if (common.isRequestSuccessful(uploadResponse.status)) {
                        return [2 /*return*/, {
                                // encode url to avoid bugs due to special characters in url
                                Location: encodeURI("".concat(uploadObj_1 === null || uploadObj_1 === void 0 ? void 0 : uploadObj_1.url).concat(key)),
                                Bucket: bucket,
                                Key: key,
                            }];
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _c.sent();
                    if (axios.isCancel(error_1)) {
                        if (onAbort)
                            onAbort();
                    }
                    else {
                        throw error_1;
                    }
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
};
var extractS3KeyFromAWSUrl = function (url) {
    return decodeURIComponent(url.split("amazonaws.com/")[1] || "");
};
/**
 * Extracts the bucket name from a given AWS S3 URL.
 * The bucket name is the string between "https://" and ".s3" in the URL.
 *
 * @param {string} s3Url - The AWS S3 URL from which to extract the bucket name.
 * @returns {string | null} - The extracted bucket name, or null if the URL is invalid or the pattern doesn't match.
 */
var getS3BucketName = function (s3Url) {
    try {
        var match = s3Url.match(/^https:\/\/(.*?)\.s3/);
        return match ? match[1] : null; // Returns the bucket name or null if not found
    }
    catch (error) {
        return null;
    }
};

exports.extractS3KeyFromAWSUrl = extractS3KeyFromAWSUrl;
exports.getS3BucketName = getS3BucketName;
exports.getS3SignedUrl = getS3SignedUrl;
exports.uploadToS3 = uploadToS3;
//# sourceMappingURL=S3.utils.js.map
